const routes = {
  MainPage: "/",
  PRIVACY_POLICY: "/privacypolicy",
  TERMS_CONDITION: "/termsCondition",
  REFUND_POLICY: "/refundPolicy",
  DISCLAIMER_Cashtap: "/disclaimerCashtap",
  SUPPORT: "/support",
  MARKET_SIZE: "/marketsize",
  CONTACT_US: "/contactus",
};
export default routes;
